import { Injectable } from "@angular/core";

import { from, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchPlansetsListData, fetchPlansetsListSuccess, fetchPlansetsListFailure, addPlansetData, addPlansetDataSuccess, addPlansetDataFailure, fetchSinglePlansetRecordData, fetchSinglePlansetRecordDataSuccess, fetchSinglePlansetRecordDataFailure, updatePlansetStatus, updatePlansetStatusSuccess, updatePlansetStatusFailure, fetchPlansetRecordComments, fetchPlansetRecordCommentsFailure, fetchPlansetRecordCommentsSuccess, fetchPlansetRecordRevisions, fetchPlansetRecordRevisionsSuccess, fetchPlansetRecordRevisionsFailure, fetchPlansetRecordholdunhold, fetchPlansetRecordholdunholdSuccess, fetchPlansetRecordholdunholdFailure, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createRevisionRecord, createRevisionRecordSuccess, createRevisionRecordFailure, createPlansetCommentRecord, createPlansetCommentRecordSuccess, createPlansetCommentRecordFailure, fetchPlansetMembersList, fetchPlansetMembersListFailure, fetchPlansetMembersListSuccess, fetchPlansetCancelReasonsList, fetchPlansetCancelReasonsListSuccess, fetchPlansetCancelReasonsListFailure, cancelPlansetRecord, cancelPlansetRecordSuccess, cancelPlansetRecordFailure, fetchPlansetAttachments, fetchPlansetAttachmentsSuccess, fetchPlansetAttachmentsFailure, editPlansetData, editPlansetDataSuccess, editPlansetDataFailure, releasePlansetRecord, releasePlansetRecordSuccess, releasePlansetRecordFailure, fetchPlansetFileAttachment, fetchPlansetFileAttachmentSuccess, fetchPlansetFileAttachmentFailure, createPlansetReviewCommentRecord, createPlansetReviewCommentRecordFailure, createPlansetReviewCommentRecordSuccess, deleteRevisionRecord, deleteRevisionRecordSuccess, deleteRevisionRecordFailure, fetchPlansetRecordViaAddressData, fetchPlansetRecordViaAddressDataFailure, fetchPlansetRecordViaAddressDataSuccess, fetchPlansetPointOfInterconnectionList, fetchPlansetPointOfInterconnectionListSuccess, fetchPlansetPointOfInterconnectionListFailure, addstructuralinfo, addstructuralinfoSuccess, addstructuralinfoFailure, updatestructuralinfoSuccess, updatestructuralinfo, updatestructuralinfoFailure, deletestructuralinfo, deletestructuralinfoSuccess, deletestructuralinfoFailure, updateplansetattachment, updateplansetattachmentSuccess, updateplansetattachmentFailure } from "./planset.actions";
import { PlansetService } from "../../core/services/planset.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { TokenStorageService } from '../../core/services/token-storage.service';
import { ToastifyService } from "../../shared/toastify-service";
import { Router } from "@angular/router";
import { PlansetModel } from "../../core/models/planset.models";
import { GenericService } from "../../core/services/generic.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { GlobalComponent } from "../../global-component";
import { collection, Timestamp, collectionData, query, where, and, or, onSnapshot, QueryConstraint, QueryCompositeFilterConstraint, orderBy } from '@angular/fire/firestore';
import { FiltersService } from "../../core/services/filters.service";


@Injectable()
export class PlansetEffects {

  currentuser: any;
  firbasebasecollname: string = 'vendors';
  subdomaincollname: string = 'subdomains';
  vendorguid!: string;

  // checkcondition(ref: any, tabId: number) {
  //   this.currentuser = this.tokenService.getUser();
  //   let isuservendor = this.genericService.getUserIsVendor();
  //   let activestateval = true;
  //   if(tabId == 6){
  //     activestateval = false;
  //   }
  //   let baseQuery = ref.where('activestate', '==', activestateval);

  //   if (!this.currentuser.usertype || !isuservendor) {
  //     baseQuery = baseQuery.where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
  //   }

  //   switch (tabId) {
  //     case 1:
  //       if (isuservendor) {
  //         if(this.currentuser.isprelimuser){

  //         }

  //         if(this.currentuser.isproductionuser){
  //           return or(and(where('jobstatus', 'in', ['accepted']), where('isprelimrequired', '==', false)),where('jobstatus', 'in', ['auroracompleted']))
  //         }
  //         return baseQuery.where('jobstatus', 'in', ['outsourced', 'accepted', 'picked']).where('isinrevisionstate', '==', false);
  //       } else {
  //         return baseQuery.where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked']).where('isinrevisionstate', '==', false);
  //       }
  //     case 2:
  //       return baseQuery.where('isinrevisionstate', '==', true).where('jobstatus', '==', 'accepted');
  //     case 3:
  //       return baseQuery.where('jobstatus', '==', 'hold');
  //     case 4:
  //       return baseQuery.where('jobstatus', 'in', ['auroraassigned', 'auroracompleted', 'productionassigned', 'productioncompleted', 'reviewassigned', 'reviewpassed', 'reviewfailed']);
  //     case 5:
  //       return baseQuery.where('jobstatus', '==', 'delivered');
  //     case 6:
  //       return baseQuery;
  //     default:
  //       return baseQuery;
  //   }
  // }

  async checkCondition(tabId: number) {
    this.currentuser = this.tokenService.getUser();
    const isuservendor = this.genericService.getUserIsVendor();
    const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/plansets`);
    let activestateval = true;
    if (tabId == 6) {
      activestateval = false;
    }

    let baseQuery = and(where('activestate', '==', activestateval));

    const filterData: any = this.filtersService.getPlansetSelectedFilters()

    // Adding Filter Queries to baseQuery
    if (filterData.clients && filterData.clients.length) {
      baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients))
    }

    if (filterData.jobtypes && filterData.jobtypes.length) {
      baseQuery = and(baseQuery, where("jobtype", "in", filterData.jobtypes))
    }

    if (filterData.states && filterData.states.length) {
      baseQuery = and(baseQuery, where("state", "in", filterData.states))
    }

    if (filterData.propertytypes && filterData.propertytypes.length) {
      baseQuery = and(baseQuery, where("propertytype", "in", filterData.propertytypes))
    }
    if (filterData.statuses && filterData.statuses.length) {
      baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses))
    }
    if (filterData.daterange && filterData.daterange.length) {
      let queryby = ""
      switch (tabId) {
        case 1:
          queryby = "createdAt"
          break
        case 2:
          queryby = "revisiondate"
          break
        case 3:
          queryby = "onholddate"
          break
        case 5:
          queryby = "deliverydate"
          break
        default:
          queryby = "createdAt"
      }
      let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0))
      let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999))
      console.log(startDate, endDate)
      if (filterData.daterange.length === 2) {
        endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999))
      }

      baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()))
    }

    const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
    let userRoleQuery: any = baseQuery;
    let memberQuery: QueryCompositeFilterConstraint | null = null;

    if (!this.currentuser.usertype || !isuservendor) {
      userRoleQuery = and(userRoleCondition, baseQuery) as QueryCompositeFilterConstraint;
    }

    switch (tabId) {
      case 1:
        if (this.currentuser.isprelimuser) {
          memberQuery = and(userRoleQuery, where('jobstatus', 'in', ['accepted']), where('isprelimrequired', '==', true), where('isinrevisionstate', '==', false));
        }

        if (this.currentuser.isproductionuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, and(or(and(where('jobstatus', 'in', ['accepted']), where('isprelimrequired', '==', false)), where('jobstatus', '==', 'auroracompleted'), and(where('jobstatus', '==', 'accepted'), where('isinrevisionstate', '==', true))), userRoleQuery));
          } else {
            memberQuery = and(or(and(where('jobstatus', 'in', ['accepted']), where('isprelimrequired', '==', false)), where('jobstatus', '==', 'auroracompleted'), and(where('jobstatus', '==', 'accepted'), where('isinrevisionstate', '==', true))), userRoleQuery);
            // memberQuery = and(userRoleQuery, or(where('jobstatus', 'in', ['accepted']), and(where('isprelimrequired', '==', false), where('isinrevisionstate', '==', false))), where('jobstatus', '==', 'auroracompleted'));
          }
        }

        if (this.currentuser.isqcuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, and(userRoleQuery, where('jobstatus', '==', 'productioncompleted')));
          } else {
            memberQuery = and(userRoleQuery, where('jobstatus', '==', 'productioncompleted'));
          }
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("createdAt", "desc"));
        }

        if (!isuservendor) {
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
        }
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));

      case 2:
        return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', true), where('jobstatus', '==', 'accepted')), orderBy("revisiondate", "desc"));

      case 3:
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', '==', 'hold')), orderBy("onholddate", "desc"));

      case 4:
        memberQuery = null;
        if (this.currentuser.isprelimuser) {
          memberQuery = or(and(where('jobstatus', 'in', ['auroracompleted']), where('auroraassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['auroraassigned']), where('activeuserguid', '==', this.currentuser.guid)));
        }

        if (this.currentuser.isproductionuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, or(and(where('jobstatus', 'in', ['productioncompleted', 'reviewfailed']), where('productionassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['productionassigned']), where('activeuserguid', '==', this.currentuser.guid))));
          } else {
            memberQuery = or(and(where('jobstatus', 'in', ['productioncompleted', 'reviewfailed']), where('productionassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['productionassigned', 'productioncompleted', 'reviewfailed']), where('activeuserguid', '==', this.currentuser.guid)));
          }
        }

        if (this.currentuser.isqcuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, or(and(where('jobstatus', 'in', ['reviewpassed', 'reviewfailed']), where('qcassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['reviewassigned']), where('activeuserguid', '==', this.currentuser.guid))));
          } else {
            memberQuery = or(and(where('jobstatus', 'in', ['reviewpassed', 'reviewfailed']), where('qcassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['reviewassigned', 'reviewpassed', 'reviewfailed']), where('activeuserguid', '==', this.currentuser.guid)));
          }
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("createdAt", "desc"));
        }

        return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['auroraassigned', 'auroracompleted', 'productionassigned', 'productioncompleted', 'reviewassigned', 'reviewpassed', 'reviewfailed'])), orderBy("createdAt", "desc"));

      case 5:
        memberQuery = null;
        if (this.currentuser.isprelimuser) {
          memberQuery = and(where('jobstatus', 'in', ['delivered']), where('auroraassigneduserguid', '==', this.currentuser.guid), where('isarchived', '==', false));
        }

        if (this.currentuser.isproductionuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, and(where('jobstatus', 'in', ['delivered']), where('productionassigneduserguid', '==', this.currentuser.guid), where('isarchived', '==', false)));
          } else {
            memberQuery = and(where('jobstatus', 'in', ['delivered']), where('productionassigneduserguid', '==', this.currentuser.guid), where('isarchived', '==', false));
          }
        }

        if (this.currentuser.isqcuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, and(where('jobstatus', 'in', ['delivered']), where('qcassigneduserguid', '==', this.currentuser.guid), where('isarchived', '==', false)));
          } else {
            memberQuery = and(where('jobstatus', 'in', ['delivered']), where('qcassigneduserguid', '==', this.currentuser.guid), where('isarchived', '==', false));
          }
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("deliverydate", "desc"));
        }

        return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false))), orderBy("deliverydate", "desc"));

      case 6:
        return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

      default:
        console.log('Invalid tabId:', tabId, orderBy("createdAt", "desc"));
        return query(vendorCollection, baseQuery);
    }
  }


  /**
   * FOR VENDOR
   */
  // Planset Fresh List Effect Of Vendor
  fetchPlansetData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetsListData),
      mergeMap(({ tabId }) =>
        from(this.checkCondition(tabId)).pipe(
          mergeMap(condition =>
            collectionData(condition).pipe(
              map((docs: any) => {
                console.log("docs", docs);
                console.log("tabId", tabId);
                const plansets = docs.map((doc: PlansetModel) => doc);
                return fetchPlansetsListSuccess({ Plansets: plansets, tabid: tabId });
              }),
              catchError((error) =>
                of(fetchPlansetsListFailure({ error, tabid: tabId }))
              )
            )
          )
        )
      )
    )
  );



  // Create Planset Record
  addPlansetData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addPlansetData),
      mergeMap(({ postdata }) =>
        this.plansetService.addPlansetsData(postdata).pipe(
          map((plansetrecord) => addPlansetDataSuccess(plansetrecord)),
          catchError((error) => of(addPlansetDataFailure({ error })))
        )
      ),
    ),
  );

  addPlansetDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addPlansetDataSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Order created successfully");
        })
      ),
    { dispatch: false }
  );

  addPlansetDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addPlansetDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Planset Record
  fetchSinglePlansetRecordData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSinglePlansetRecordData),
      mergeMap(({ recordguid }) =>
        this.plansetService.getPlansetsRecordData(recordguid).pipe(
          map((plansetrecord) => fetchSinglePlansetRecordDataSuccess({ plansetrecord })),
          catchError((error) => of(fetchSinglePlansetRecordDataFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Planset Record
  updatePlansetStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updatePlansetStatus),
      mergeMap(({ recordguid, postdata }) =>
        this.plansetService.updatePlansetStatus(recordguid, postdata).pipe(
          map(() => updatePlansetStatusSuccess()),
          catchError((error) => of(updatePlansetStatusFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Planset Record
  updatePlansetStatusSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updatePlansetStatusSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Order updated successfully");
          // this.router.navigate(['../']);
        })
      ),
    { dispatch: false }
  );

  updatePlansetStatusFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updatePlansetStatusFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Planset Comments Record
  fetchPlansetRecordComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetRecordComments),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('plansetcomments', recordguid, 'createdAt:DESC').pipe(
          map((comments) => fetchPlansetRecordCommentsSuccess({ comments: comments })),
          catchError((error) => of(fetchPlansetRecordCommentsFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetRecordCommentsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetRecordCommentsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Planset Revisions Record
  fetchPlansetRecordRevisions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetRecordRevisions),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('plansetrevisionjobs', recordguid, 'createdAt:DESC').pipe(
          map((revisions) => fetchPlansetRecordRevisionsSuccess({ revisions: revisions })),
          catchError((error) => of(fetchPlansetRecordRevisionsFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetRecordRevisionsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetRecordRevisionsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Planset Hold/Unhold Record
  fetchPlansetRecordholdunhold$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetRecordholdunhold),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('plansetholdjobs', recordguid, 'createdAt:DESC').pipe(
          map((holdunholdrecords) => fetchPlansetRecordholdunholdSuccess({ holdunhold: holdunholdrecords })),
          catchError((error) => of(fetchPlansetRecordholdunholdFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetRecordholdunholdFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetRecordholdunholdFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // HOLD RECORD CREATE
  createHoldRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createHoldRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('plansetholdjobs', postdata).pipe(
          map((holdrecord: any) => createHoldRecordSuccess({ holdrecord })),
          catchError((error) => of(createHoldRecordFailure({ error })))
        )
      ),
    ),
  );

  createHoldRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createHoldRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.holdsuccess);
        })
      ),
    { dispatch: false }
  );

  createHoldRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createHoldRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // HOLD RECORD CREATE
  createRevisionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createRevisionRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('plansetrevisionjobs', postdata).pipe(
          map((revisionrecord) => createRevisionRecordSuccess({ revisionrecord })),
          catchError((error) => of(createRevisionRecordFailure({ error })))
        )
      ),
    ),
  );

  createRevisionRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRevisionRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.holdsuccess);
        })
      ),
    { dispatch: false }
  );

  createRevisionRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRevisionRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // COMMENT CREATE
  createPlansetCommentRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createPlansetCommentRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('plansetcomments', postdata).pipe(
          map((comment) => createPlansetCommentRecordSuccess({ comment })),
          catchError((error) => of(createPlansetCommentRecordFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Planset Comments Record
  fetchPlansetMembersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetMembersList),
      mergeMap(({ recordguid }) =>
        this.plansetService.getPlansetsMembersList(recordguid).pipe(
          map((list) => fetchPlansetMembersListSuccess({ memberslist: list })),
          catchError((error) => of(fetchPlansetMembersListFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetMembersListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetMembersListFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  createPlansetCommentRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createPlansetCommentRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH CANCEL REASONS FROM FIREBASE
  fetchPlansetCancelReasonsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetCancelReasonsList),
      mergeMap(() =>
        this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
          .valueChanges().pipe(
            map((docs: any) => {
              console.log(":docs", docs)
              return fetchPlansetCancelReasonsListSuccess({ reasons: docs });
            }),
            catchError((error) =>
              of(fetchPlansetCancelReasonsListFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchPlansetCancelReasonsListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetCancelReasonsListFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  // CANCEL PLANSET PROJECT
  cancelPlansetRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cancelPlansetRecord),
      mergeMap(({ postdata }) =>
        this.plansetService.cancelPlansetProject(postdata).pipe(
          map(() => cancelPlansetRecordSuccess()),
          catchError((error) => of(cancelPlansetRecordFailure({ error })))
        )
      ),
    ),
  );

  cancelPlansetRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cancelPlansetRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
        })
      ),
    { dispatch: false }
  );

  cancelPlansetRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cancelPlansetRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH ATTACHMENTS OF PLANSET RECORD
  fetchPlansetAttachments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetAttachments),
      mergeMap(({ jobguid }) =>
        this.plansetService.getPlansetsAttachments(jobguid).pipe(
          map((attachments) => fetchPlansetAttachmentsSuccess({ attachments })),
          catchError((error) => of(fetchPlansetAttachmentsFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetAttachmentsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetAttachmentsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Create Planset Record
  editPlansetData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editPlansetData),
      mergeMap(({ postdata, recordId }) =>
        this.plansetService.editPlansetsData(postdata, recordId).pipe(
          map((plansetrecord) => editPlansetDataSuccess(plansetrecord)),
          catchError((error) => of(editPlansetDataFailure({ error })))
        )
      ),
    ),
  );

  editPlansetDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editPlansetDataSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Order updated successfully");
        })
      ),
    { dispatch: false }
  );

  editPlansetDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editPlansetDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
   * RELEASE PLANSET RECORD
   */
  releasePlansetRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(releasePlansetRecord),
      mergeMap(({ recordguid, postdata }) =>
        this.plansetService.releaserecord(recordguid, postdata).pipe(
          map(() => releasePlansetRecordSuccess()),
          catchError((error) => of(releasePlansetRecordFailure({ error })))
        )
      ),
    ),
  );

  releasePlansetRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releasePlansetRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Record released successfully");
          // this.router.navigate(['../']);
        })
      ),
    { dispatch: false }
  );

  releasePlansetRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releasePlansetRecordFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH ATTACHMENTS OF PLANSET RECORD
  fetchPlansetFileAttachment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetFileAttachment),
      mergeMap(({ jobguid }) =>
        this.plansetService.getPlansetFile(jobguid).pipe(
          map((attachments) => fetchPlansetFileAttachmentSuccess({ attachments })),
          catchError((error) => of(fetchPlansetFileAttachmentFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetFileAttachmentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetFileAttachmentFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //REVIEW COMMENT CREATE
  // COMMENT CREATE
  createPlansetReviewCommentRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createPlansetReviewCommentRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('plansetcomments', postdata).pipe(
          map((comment) => createPlansetReviewCommentRecordSuccess({ comment })),
          catchError((error) => of(createPlansetReviewCommentRecordFailure({ error })))
        )
      ),
    ),
  );

  createPlansetReviewCommentRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createPlansetReviewCommentRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
   * REVISION DELETE
   */
  deleteRevisionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteRevisionRecord),
      mergeMap(({ id }) =>
        this.plansetService.deleterevision(id).pipe(
          map(() => deleteRevisionRecordSuccess()),
          catchError((error) => of(deleteRevisionRecordFailure({ error })))
        )
      ),
    ),
  );

  deleteRevisionRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteRevisionRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Revision deleted and moved to delivered successfully");
        })
      ),
    { dispatch: false }
  );

  deleteRevisionRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteRevisionRecordFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Planset Record
  fetchPlansetRecordViaAddressData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPlansetRecordViaAddressData),
      mergeMap(({ address, clientguid }) =>
        this.plansetService.getPlansetsRecordDataViaAddress(address, clientguid).pipe(
          map((plansetrecord) => fetchPlansetRecordViaAddressDataSuccess({ plansetrecord })),
          catchError((error) => of(fetchPlansetRecordViaAddressDataFailure({ error })))
        )
      ),
    ),
  );

  fetchPlansetRecordViaAddressDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPlansetRecordViaAddressDataFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

// FETCH POINT OF INTERCONNECTION FROM FIREBASE
fetchPlansetPointOfInterconnectionList$ = createEffect(() =>
  this.actions$.pipe(
    ofType(fetchPlansetPointOfInterconnectionList),
    mergeMap(() =>
      this.afs.collection(GlobalComponent.firebasepointofinterconnectioncollname).doc('JdXcIizt5Gzyt3ICQdxU')
        .valueChanges().pipe(
          map((docs: any) => {
            console.log(":docs point of interconnection ----", docs)
            return fetchPlansetPointOfInterconnectionListSuccess({ pointofinterconnectiondata: docs });
          }),
          catchError((error) =>
            of(fetchPlansetPointOfInterconnectionListFailure({ error }))
          )
        )
    ),
  ),
);

// ADD STRUCTURAL INFORMATION DATA
addstructuralinfo$ = createEffect(() =>
  this.actions$.pipe(
    ofType(addstructuralinfo),
    mergeMap(({ postdata }) =>
      this.plansetService.addStructuralInformation(postdata).pipe(
        map((data: any) =>{
          return addstructuralinfoSuccess({ structuralinfodata: data });
        }),
        catchError((error) => of(addstructuralinfoFailure({ error })))
      )
    ),
  ),
);

addstructuralinfoSuccess$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(addstructuralinfoSuccess),
      tap(() => {
        this.toastifyService.showSuccessMessage("Structural information added successfully");
      })
    ),
  { dispatch: false }
);

addstructuralinfoFailure$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(addstructuralinfoFailure),
      tap((error: any) => {
        this.toastifyService.showErrorMessage(error.error.message);
      })
    ),
  { dispatch: false }
);

// EDIT STRUCTURAL INFORMATION DATA
updatestructuralinfo$ = createEffect(() =>
  this.actions$.pipe(
    ofType(updatestructuralinfo),
    mergeMap(({ structuralinforecordid, postdata }) =>
      this.plansetService.updateStructuralInformation(structuralinforecordid, postdata).pipe(
        map((data: any) =>{
          return updatestructuralinfoSuccess({ structuralinforecord: data });
        }),
        catchError((error) => of(updatestructuralinfoFailure({ error })))
      )
    ),
  ),
);

updatestructuralinfoSuccess$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(updatestructuralinfoSuccess),
      tap(() => {
        this.toastifyService.showSuccessMessage("Roof updated successfully");
      })
    ),
  { dispatch: false }
);

updatestructuralinfoFailure$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(updatestructuralinfoFailure),
      tap((error: any) => {
        this.toastifyService.showErrorMessage(error.error.message);
      })
    ),
  { dispatch: false }
);

// DELETE STRUCTURAL INFORMATION DATA
deletestructuralinfo$ = createEffect(() =>
  this.actions$.pipe(
    ofType(deletestructuralinfo),
    mergeMap(({ structuralinforecordid, postdata }) =>
      this.plansetService.updateStructuralInformation(structuralinforecordid, postdata).pipe(
        map((data: any) =>{
          return deletestructuralinfoSuccess({ structuralinforecord: data });
        }),
        catchError((error) => of(deletestructuralinfoFailure({ error })))
      )
    ),
  ),
);

deletestructuralinfoSuccess$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(deletestructuralinfoSuccess),
      tap(() => {
        this.toastifyService.showSuccessMessage("Roof updated successfully");
      })
    ),
  { dispatch: false }
);

deletestructuralinfoFailure$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(deletestructuralinfoFailure),
      tap((error: any) => {
        this.toastifyService.showErrorMessage(error.error.message);
      })
    ),
  { dispatch: false }
);

// UPDATE PLANSET ATTACHMENT VIA ID
updateplansetattachment$ = createEffect(() =>
  this.actions$.pipe(
    ofType(updateplansetattachment),
    mergeMap(({ attachmentId, postdata }) =>
      this.plansetService.updatePlansetsAttachment(attachmentId, postdata).pipe(
        map(() => updateplansetattachmentSuccess()),
        catchError((error) => of(updateplansetattachmentFailure({ error })))
      )
    ),
  ),
);

updateplansetattachmentFailure$ = createEffect(
  () =>
    this.actions$.pipe(
      ofType(updateplansetattachmentFailure),
      tap((error: any) => {
        this.toastifyService.showErrorMessage(error.error.message);
      })
    ),
  { dispatch: false }
);

  constructor(
    private actions$: Actions,
    private afs: AngularFirestore,
    private tokenService: TokenStorageService,
    private plansetService: PlansetService,
    private toastifyService: ToastifyService,
    private router: Router,
    private genericService: GenericService,
    private commonService: CommonAPIService,
    private filtersService: FiltersService
  ) {
  }
}
